export default __webpack_public_path__ + "static/media/endRound11.a0891990.mp3";